import { HIGH, LOW, MEDIUM, NONE } from 'customer-data-objects/engagement/taskPriorities';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { PRIORITY } from 'customer-data-objects/task/TaskPropertyNames';
import getIn from 'transmute/getIn';
import once from 'transmute/once';
import toJS from 'transmute/toJS';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { TABLE_PROPERTIES } from '../../constants/properties';
import { useTaskProperties } from '../../hooks/properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRIORITY_TO_STATUS_USE = {
  [LOW]: 'active',
  [MEDIUM]: 'warning',
  [HIGH]: 'danger'
};
const getPriorityLabels = once(propertyDefinitionOptions => {
  return propertyDefinitionOptions.reduce((acc, option) => {
    if (!option.value || !option.label) {
      return acc;
    }
    return Object.assign(acc, {
      [option.value]: option.label
    });
  }, {});
});
const TaskPriorityCell = ({
  original: cdtTask
}) => {
  const {
    loading,
    properties
  } = useTaskProperties(TABLE_PROPERTIES);
  const priority = getProperty(cdtTask, PRIORITY);
  if (loading || !priority || priority === NONE) {
    return null;
  }
  const propertyDefinitionOptions = toJS(getIn([PRIORITY, 'options'], properties)) || [];
  const priorityOptionsToLabels = getPriorityLabels(propertyDefinitionOptions);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIStatusDot, {
      "data-test-id": `status-dot-${priority}`,
      use: PRIORITY_TO_STATUS_USE[priority]
    }), priorityOptionsToLabels[priority]]
  });
};
export default TaskPriorityCell;